import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { LogoMark } from "../components/Logo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    if (!sessionId) {
      setStatus("unknown");
      return;
    }
    let tries = 0;
    const timer = setInterval(async () => {
      tries += 1;
      try {
        const { data } = await fetch(`${API}/payments/status/${sessionId}`).then((r) => r.json());
        if (data.payment_status === "paid") {
          clearInterval(timer);
          setStatus("paid");
        } else if (tries > 20) {
          clearInterval(timer);
          setStatus(data.payment_status || "pending");
        }
      } catch (e) {
        if (tries > 20) {
          clearInterval(timer);
          setStatus("pending");
        }
      }
    }, 2500);
    return () => clearInterval(timer);
  }, [sessionId]);

  return (
    <div className="grid min-h-screen place-items-center bg-ink px-5 text-sand" data-testid="payment-success">
      <div className="max-w-md text-center">
        <LogoMark dark className="mx-auto h-12 w-12" />
        {status === "paid" && (
          <>
            <CheckCircle2 className="mx-auto mt-8 h-14 w-14 text-[#1fa855]" />
            <h1 className="mt-4 font-serif text-3xl">Acconto ricevuto, grazie!</h1>
            <p className="mt-3 text-sm leading-relaxed text-sand/70">
              Il tuo acconto è stato registrato. Ti contatteremo al più presto per confermare la prenotazione.
            </p>
          </>
        )}
        {(status === "checking" || status === "pending") && (
          <>
            <Loader2 className="mx-auto mt-8 h-14 w-14 animate-spin text-terra" />
            <h1 className="mt-4 font-serif text-3xl">Verifica del pagamento…</h1>
            <p className="mt-3 text-sm text-sand/70">Un momento, stiamo confermando la transazione.</p>
          </>
        )}
        {["failed", "expired", "unknown"].includes(status) && (
          <>
            <XCircle className="mx-auto mt-8 h-14 w-14 text-terra" />
            <h1 className="mt-4 font-serif text-3xl">Pagamento non confermato</h1>
            <p className="mt-3 text-sm text-sand/70">
              Se hai completato il pagamento, scrivici su WhatsApp al +39 380 146 6883: verifichiamo subito.
            </p>
          </>
        )}
        <a
          href="/"
          data-testid="payment-back"
          className="mt-8 inline-block rounded-full border border-sand/30 px-6 py-3 text-xs font-semibold uppercase tracking-[0.18em] transition-colors duration-300 hover:bg-sand hover:text-ink"
        >
          Torna al sito
        </a>
      </div>
    </div>
  );
}

export function PaymentCancel() {
  return (
    <div className="grid min-h-screen place-items-center bg-ink px-5 text-sand" data-testid="payment-cancel">
      <div className="max-w-md text-center">
        <LogoMark dark className="mx-auto h-12 w-12" />
        <XCircle className="mx-auto mt-8 h-14 w-14 text-terra" />
        <h1 className="mt-4 font-serif text-3xl">Pagamento annullato</h1>
        <p className="mt-3 text-sm text-sand/70">
          Nessun addebito. Se vuoi riprovare o preferisci un altro metodo, scrivici su WhatsApp al +39 380 146 6883.
        </p>
        <a
          href="/"
          data-testid="payment-cancel-back"
          className="mt-8 inline-block rounded-full border border-sand/30 px-6 py-3 text-xs font-semibold uppercase tracking-[0.18em] transition-colors duration-300 hover:bg-sand hover:text-ink"
        >
          Torna al sito
        </a>
      </div>
    </div>
  );
}
